export var formatPublisherPrefixLabel = function (prefix) {
    var _a, _b, _c, _d, _e, _f;
    var intPrefix = ((_c = (_b = (_a = prefix.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix) === null || _b === void 0 ? void 0 : _b.internationalPrefix) === null || _c === void 0 ? void 0 : _c.value) || "";
    var agencyPrefix = ((_e = (_d = prefix.publisherPrefixRange) === null || _d === void 0 ? void 0 : _d.agencyPrefix) === null || _e === void 0 ? void 0 : _e.value) || "";
    var publisherValue = prefix.value || "";
    var publisherName = ((_f = prefix.publisher) === null || _f === void 0 ? void 0 : _f.name) || "";
    var prefixParts = [intPrefix, agencyPrefix, publisherValue]
        .filter(Boolean)
        .join("-");
    return publisherName ? "".concat(prefixParts, " \u2014 ").concat(publisherName) : prefixParts;
};
